import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import Network from "./network/Network";
import instId from "./network/instituteId";
import axios from "axios";
import { BASE_URL } from "./network/endpoints";
import { useLocation } from "react-router-dom";

const DefaultModal = () => {

    const location = useLocation();
    const [openModal, setOpenModal] = useState(false);
    const [anncouncementData, setAnncouncementData] = useState(true);
    const [endpointsUrl, setEndpointsUrl] = useState('');

    useEffect(() => {
        getAllAnnouncement();
    }, [])

    useEffect(() => {
        if (location?.pathname === "/" && anncouncementData?.length > 0) {
            setOpenModal(true)
        }
    }, [location, anncouncementData])

    useEffect(() => {
        if (anncouncementData?.length > 0) {
            getInstituteDetail();
        }

    }, [anncouncementData])

    const getInstituteDetail = async () => {
        try {
            let requestOptions = {
                // headers: { "X-Auth": token },
                withCredentials: false,
            };
            const response = await axios.get(
                BASE_URL + "/getMetaData/fetch-institute/" + instId,
                requestOptions
            );
            if (response?.data?.errorCode === 0) {


                setEndpointsUrl(response?.data?.instituteTechSetting?.mediaUrl);
            };
        } catch (error) {
            console.log(error);
        }
    };
    const getAllAnnouncement = async () => {
        const response = await Network.fetchAnnouncementUrl(instId);
        setAnncouncementData(response?.announcement);
    };

    return (
        <Box>
            <Dialog open={openModal} onClose={() => setOpenModal(false)}>
                <DialogContent sx={{ flex: 1, padding: 0 }}>
                    <Box sx={{ textAlign: 'end', width: "100%" }}>
                        <IconButton
                            aria-label="close"
                            onClick={() => setOpenModal(false)}
                        >
                            <CloseIcon fontSize="large" />
                        </IconButton>
                    </Box>
                    <Divider sx={{
                        width: "100%",
                        height: "fit-content",
                        backgroundColor: "#e0e0e0",
                    }} />
                    <Grid container sx={{ height: "100%" }}>
                        <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" sx={{ height: "100%", padding: "20px" }}>
                            {
                                anncouncementData?.length > 0 && (
                                    <img
                                        onClick={() => {
                                            if (anncouncementData[anncouncementData.length - 1]?.contentLink) {
                                                window.open(anncouncementData[anncouncementData.length - 1].contentLink, '_blank', 'noreferrer');
                                            }
                                        }}
                                        // src="img/19.jpg"
                                        src={endpointsUrl + anncouncementData[anncouncementData.length - 1]?.image}
                                        style={{ width: "100%", height: '100%' }} />
                                )
                            }

                        </Grid>
                    </Grid>
                </DialogContent>
                {/* <DialogActions>
                    <Button onClick={() => setOpenModal(false)}>Close</Button>
                </DialogActions> */}
            </Dialog>
        </Box>
    )
};

export default DefaultModal;